var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7196 11.4L17.5196 13.21C17.9819 13.6799 18.1178 14.381 17.8648 14.9896C17.6117 15.5983 17.0188 15.9963 16.3596 16H12.9996V16.34C12.9024 18.4537 11.1136 20.0904 8.99963 20C6.88565 20.0904 5.09688 18.4537 4.99963 16.34V16H1.63963C0.980463 15.9963 0.387571 15.5983 0.134507 14.9896C-0.118558 14.381 0.0173911 13.6799 0.479629 13.21L2.27963 11.4V6.72999C2.28317 4.79116 3.12147 2.94776 4.58035 1.67076C6.03924 0.393754 7.97739 -0.19315 9.89963 0.0599949C13.2851 0.578881 15.7691 3.51534 15.7196 6.93999V11.4ZM8.99963 18C10.003 18.0708 10.8844 17.3393 10.9996 16.34V16H6.99963V16.34C7.11484 17.3393 7.99622 18.0708 8.99963 18Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.798b3975acab74e9d765019a798cb8fd.svg";
export { ForwardRef as ReactComponent };